<template>
  <div
    :key="key"
    v-tooltip="{
    content: `${returnText(active)}`,
    placement:'bottom',
    }"
    :data-id="id"
    :data-requestid="requestid"
    :title="returnText(active)"
    :class="active?'active':''"
    @click="bookmark"
    class="bookmark"
  >
    <svg v-if="!isSaveJobView" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
      <path d="M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z" />
    </svg>
    <img v-if="isSaveJobView" src="asset/image/icon/Group853.svg" alt="" class="close-btn">
  </div>
</template>
<script>
export default {
  props: {
    id: {
      default: '0',
      type: String
    },
    source: {
      default: 'unknown',
      type: String
    },
    requestid: {
      default: '',
      type: String
    },
    isSaveJobView: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      active: false,
      login: false,
      key: 0
    }
  },
  mounted() {
    this.login = this.$auth.loggedIn
    // sync bookmark
    const bookmark = this.$cpCookie.get('bookmark')
    let bookmarkArr = []
    if (bookmark !== undefined) {
      bookmarkArr = bookmark.toString().split(',')
    }
    if (bookmarkArr.includes(this.id)) {
      this.active = true
    } else {
      this.active = false
    }
    this.key = Math.random()
  },
  methods: {
    returnText: function(active) {
      return active ? this.cpLang('jd.unsave') : this.cpLang('jd.save')
    },
    bookmark: function (e) {
      e.stopPropagation()
      e.preventDefault()
      const bookmark = this.$cpCookie.get('bookmark')
      let bookmarkArr = []
      if (bookmark !== undefined) {
        bookmarkArr = bookmark.toString().split(',')
      }
      const bookmarkObj = {
        'Position ID': this.id,
        'Bookmark Source': this.source,
        'Bookmark Status': ''
      }
      if (bookmarkArr.includes(this.id)) {
        if (this.login) {
          this.saveBookmark(this.id, 'unsave')
          // console.log('Logged In, Call API delete Bookmark')
        }
        const idx = bookmarkArr.indexOf(this.id)
        if (idx !== -1) bookmarkArr.splice(idx, 1)
        this.active = false
        this.$emit('unsave', this.id)
        bookmarkObj['Bookmark Status'] = 'removed'
        this.$gtm.pushEvent({
          event: 'positionBookmark',
          ...bookmarkObj
        })
      } else {
        if (this.login) {
          this.saveBookmark(this.id, 'save')
          // console.log('Logged In, Call API set Bookmark')
        }
        bookmarkArr.push(this.id)
        this.active = true
        bookmarkObj['Bookmark Status'] = 'added'
        this.$emit('save', this.id)
        this.$gtm.pushEvent({
          event: 'positionBookmark',
          ...bookmarkObj
        })
      }
      // console.log('Cookie', bookmarkArr)
      this.key = Math.random()
      this.$cpCookie.set('bookmark', bookmarkArr.join(','), {
        path: '/',
        maxAge: 60 * 60 * 24 * 3
      })
    },
    saveBookmark: async function (id, action) {
      if (this.login) {
        if (action === 'save') {
          const params = {
            posid: id,
            requestid: this.requestid
          }
          await this.$store.dispatch('user/saveBookmark', params)
        }
        if (action === 'unsave') {
          await this.$store.dispatch('user/unsaveBookmark', id)
        }
      }
    }
  }
}

</script>

<style lang="scss">
  .bookmark {
    width: 20px;
    cursor: pointer;
    transition: 0.2s;
    position: absolute;
    right: 15px;
    top: -8px;

    svg {
      height: 20px;
      width: auto;
      transition: .3s;
      fill: rgba(220, 220, 220, 1);
    }

    &.active {
      svg {
        fill: #0EA5BF !important;
      }
    }
  }

</style>
